import { Dialog, DialogContent, IconButton} from "@mui/material";
import { Close } from "@material-ui/icons";
import { grey } from "@mui/material/colors";

export const VideoModal = (props) => {
    const { children, onClose, ...other } = props;
    return (
        <Dialog className="Dialog"sx={{ m: 0, p: 0 }} {...other} fullWidth="lg" maxWidth="lg" onClose={onClose}>
            <DialogContent>
                {children}
            </DialogContent>
            {
            onClose ? 
                (
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        sx=
                        {{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: grey[500],
                        }}
                    >
                    <Close className="close" sx={{ height:'2rem', width:'2rem'}}/>
                    </IconButton>
                ) : null
            }
        </Dialog>
    );
};